import { render, staticRenderFns } from "./DonateRegist.vue?vue&type=template&id=281148f5&scoped=true"
import script from "./DonateRegist.vue?vue&type=script&lang=js"
export * from "./DonateRegist.vue?vue&type=script&lang=js"
import style0 from "./DonateRegist.vue?vue&type=style&index=0&id=281148f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281148f5",
  null
  
)

export default component.exports